import { Redirect } from 'models/redirect';
import {Agent, request} from './base';
import { SeqOffer } from 'models/seq-offer';

export class SeqOffersAgent extends Agent<SeqOffer> {
    constructor() {
        super(SeqOffer, '/seq-offer');
    }

    sync = async () => {
        await request.post('/seq-offer/sync', {});
    };

    duplicate = async (id: any) => {
        await request.post(`/seq-offer/duplicate/${id}`, {});
    };

    fetchTranslations = async () => {
        return request.get('/seq-offer/translations', {});
    };

    uploadTranslations = async (file: any) => {
        const formData  = new FormData();
      
        formData.append('file', file);
      
        await fetch(`${process.env.REACT_APP_API_URL}/seq-offer/translations/upload`, {
          method: 'POST',
          body: formData,
          credentials: 'include'
        });
    };
}
